import { Avatar } from 'primereact/avatar';
import { useTranslation } from 'react-i18next';

import { AllowAccess } from '@features/auth/ControlAccess/AllowAccess/AllowAccess';
import { billingDetailsAccessRights } from '@features/campaigns/details/consts/billingDetailsAccessRights';
import { BillingDetailsData } from '@features/campaigns/details/containers/BillingDetails/BillingDetails.dto.ts';
import BillingDetails from '@features/campaigns/details/containers/BillingDetails/BillingDetails.tsx';
import { DetailsAndStatusData } from '@features/campaigns/details/containers/CampaignDetailsPage/CampaignDetailsPage.dto';
import { AccessRight } from '@shared/api/commonApiInterfaces.ts';
import { Item } from '@shared/components/Review/Item/Item';
import StatusIcon from '@shared/components/StatusIcon/StatusIcon';
import { i18nNameSpace } from '@shared/consts/i18n';

import styles from './DetailsAndStatus.module.scss';

interface DetailsAndStatusProps {
  data: DetailsAndStatusData;
  formData: BillingDetailsData;
  accessRights: AccessRight[];
  isOnboardingCompleted: boolean;
}

const checkIfHasAnyBillingDetailsAccessRight = (accessRights: AccessRight[]) => {
  return billingDetailsAccessRights.some((billingDetailsAccessRight) =>
    accessRights.includes(billingDetailsAccessRight),
  );
};

function DetailsAndStatus({ data, formData, accessRights, isOnboardingCompleted }: DetailsAndStatusProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);
  const hasAnyBillingDetailsAccessRight = checkIfHasAnyBillingDetailsAccessRight(accessRights);

  return (
    <section className={styles.wrapper}>
      <header className={styles.header}>
        <h3 className={styles.text}>{t('page.campaignDetails.campaignDetailsTab.sectionTitles.detailsAndStatus')}</h3>
      </header>
      <div className={styles.cardContent} data-testid='details-and-status-section'>
        <div className='grid'>
          <div className='row'>
            <div className={'col-12'}>
              <Item label={t('page.campaignDetails.campaignDetailsTab.labels.campaignStatus')}>
                <StatusIcon variant={data.campaignStatus} />
                {t(`page.list.campaignStatus.${data.campaignStatus.toLowerCase()}`)}
              </Item>
            </div>
          </div>
          {/*<div className={'col-12'}>*/}
          {/*  /!* TODO: replace hardcoded billing status value *!/  */}
          {/* Placeholder temporary disabled, enable when billing status will be functional */}
          {/*  <Item label={t('page.campaignDetails.campaignDetailsTab.labels.billingStatus')} value={'Unpaid'} />*/}
          {/*</div>*/}
          <div className='row'>
            <div className={'col-12'}>
              <Item label={t('page.campaignDetails.campaignDetailsTab.labels.creator')}>
                <Avatar className={styles.avatar} icon='pi pi-user' shape='circle' />
                {data.creator}
              </Item>
            </div>
          </div>

          <AllowAccess additionalCondition={hasAnyBillingDetailsAccessRight}>
            <BillingDetails
              data={formData}
              accessRights={accessRights}
              campaignStatus={data.campaignStatus}
              campaignType={data.campaignType}
              isOnboardingCompleted={isOnboardingCompleted}
            />
          </AllowAccess>
        </div>
      </div>
    </section>
  );
}

export default DetailsAndStatus;
